import { useState, useEffect } from "react"

const ThemeContext = React.createContext({
  value: "dark",
  toggleTheme: ()=>{}
})

const THEME_COOKIE_NAME = "CR_News_lightmode";
const THEME_COOKIE_MAX_AGE = 365 * 24 * 60 * 60; // 365 days

function ThemeProvider({ children }) {
  const [themeContextState, setThemeContextState] = useState("dark");

  if (document.cookie.includes(THEME_COOKIE_NAME + "=true")) {
    SetThemeClass("light");
  }

  useEffect(() => {
    // Check theme on page load
    if (BodyHasLightClass()) {
      setThemeContextState("light");
    }
  }, []);

  function handleToggleTheme() {
    let lightClassExists = BodyHasLightClass();
    let newTheme = lightClassExists ? "dark" : "light";
    setThemeContextState(newTheme);
    SetThemeClass(newTheme);
    document.cookie =
      THEME_COOKIE_NAME +
      "=" +
      (newTheme === "light" ? "true" : "false") +
      ";max-age=" +
      THEME_COOKIE_MAX_AGE +
      ";path=/";
  }

  function SetThemeClass(lightMode) {
    let lightClassExists = BodyHasLightClass();
    let bodyEle = GetBodyEle();
    if (bodyEle) {
      if (lightClassExists && lightMode === "dark") {
        bodyEle.classList.remove("light");
      }
      if (!lightClassExists && lightMode === "light") {
        bodyEle.classList.add("light");
      }
    }
  }

  function BodyHasLightClass() {
    let bodyEle = GetBodyEle();
    if (bodyEle && bodyEle.classList.contains("light")) {
      return true;
    }
    return false;
  }
  function GetBodyEle() {
    const eleList = document.getElementsByTagName("body");
    if (eleList && eleList.length > 0) {
      return eleList[0];
    }
    return null;
  }

  return (
    <ThemeContext.Provider
      value={{ value: themeContextState, toggleTheme: handleToggleTheme }}
    >
      {children}
    </ThemeContext.Provider>
  );
}

export default ThemeProvider
export { ThemeContext }